/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Lightbox } from '@nexigendigital/nxui'
import { FormikProps } from 'formik'

import RenewDomainForm from 'containers/domains/forms/renewDomainForm'

/**********************************************************************************************************
 *   INTERFACE
 **********************************************************************************************************/
interface Props {
    id: number,
    status: boolean,
    close: () => void
}

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function RenewDomainLightbox({ id, status, close }: Props) {
    const formRef = useRef<FormikProps<{ promo_code: string, billing_cycle_id: number }>>(null)

    /*   RENDER COMPONENT
    **********************************************************************************************************/
    return (
        <Lightbox
            title={'Renew Domain Name'}
            description={'Ensure your domain name remains registered by renewing it before it expires.'}
            content={<RenewDomainForm id={id} form={formRef} close={close}/>}
            conditions={{ state: status, action: () => close() }}
            links={[]}
            actions={[
                {
                    label: 'Back',
                    color: 'secondary',
                    func: () => close()
                },
                {
                    label: 'Generate Renewal Invoice',
                    color: 'primary',
                    type: 'submit',
                    form: 'renewDomainForm'
                }
            ]}
        />
    )
}
